import { render, staticRenderFns } from "./ReportsDetail.vue?vue&type=template&id=1f5f0559"
import script from "./ReportsDetail.vue?vue&type=script&lang=js"
export * from "./ReportsDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports